

<template>
  <section class="section section-lg bg-default">
    <div v-if="!showReceipt" class="container container-wide">
  <br>
  <br>
  <br>
  <p id="noReceipt">{{this.eowp.receiptUnavailable}}</p>
  <br>
  <br>
  <br>
</div>
    <div v-if="showReceipt" class="container container-wide">
        <input type="hidden" name="submitting" id="submitting" value="" />

        <!-- contents ここから -->
        <div id="print_caution">
          <p class="print_caution_title">{{eowp.receiptPrintCautionTitle}}</p><br/>
          <p class="print_caution_p" v-html="eowp.receiptPrintCaution">
              {{eowp.receiptPrintCaution}}
          </p><br/>
          <p class="print_link">→ <a href="#!" @click="printReceipt()">印刷する</a></p>
        </div>
        <br />
        <!-- DESKTOP VERSION ---------------------->
        <div id="container" name="fm1" class='receipt-details-standard'>
        <img src="../../assets/ALClogo-3-blk.png"
            id="logo"/>
            <span class="caption">ALC PRESS INC.</span>
        <!--右上-->
        <div id="top_right">
            <div class="t_column clearfix">
            <p class="t_topic">決済確認日<br />INVOICE DATE</p>
              <span id="invoice-date" class="field">{{this.eowp.receiptParams.invoiceDate}}</span>
            </div>
            <div class="t_column clearfix">
            <p class="t_topic">注文番号<br />ORDER NUMBER</p>
              <span id="order-number" class="field">{{this.eowp.receiptParams.orderNumber}}</span> 
            </div>
            <div class="t_column clearfix">
            <p class="t_topic">照会番号<br />INQUIRY NUMBER</p>
             <span id="inquiry-number" class="field">{{this.eowp.receiptParams.inquiryNumber}}</span>
            </div>
        </div>
        <!--右上終わり-->
        <div id="main">
            <h2 id="receipt">領収書<br />RECEIPT</h2>
            <p id="certify">
            下記、正に領収いたしました。<br />This is to certify that ALC PRESS
            INC. has received the following.
            </p>
            <div class="m_column">
            <div class="m_topic">
                <p class="m_topic_p">宛名<br />RECEIVED FROM</p>
            </div>
            <div class="m_column_body">
                <p id="sama">様</p>
            </div>
            </div>
            <div class="m_column clearfix">
            <div class="m_topic">
                <p class="m_topic_p">金額<br />THE SUM OF</p>
            </div>
            <div id="sum_fields">
                <p id="yen">&#165;</p>
                <span id="sum" class="field">{{this.eowp.receiptParams.paymentPrice}}<br /></span>
                <p id="credit_card">クレジットカードによるお支払い</p>
            </div>
            </div>
            <div class="m_column clearfix">
            <div class="m_topic">
                <p class="m_topic_p">但し<br />IN PAYMENT OF</p>
            </div>
            <div class="m_column_body">
                <p id="payment_p" v-if="this.$route.query.subscriptionType == this.eowp.receiptType.yearly">
                <span id="payment-of" class="field">
                    {{eowp.receiptParams.itemName}}ご利用料金({{this.formatDateSpecific(eowp.receiptParams.invoiceDate)}} - {{this.formatDateSpecific(eowp.receiptParams.expireDate)}}分)
                </span>
                </p>
                <p id="payment_p" v-else>
                <span id="payment-of" class="field">
                    {{eowp.receiptParams.itemName}}ご利用料金({{this.formatDateSpecific(eowp.receiptParams.invoiceDate)}}分)
                </span>
                </p>
            </div>
            </div>
            <p id="notification">
            本紙は電子的に保持している領収データを画面上で表示したものです<br />This
            is an electronic display of receipt data.
            </p>
            <div id="footer">
              <div class="f_box">
                  <p><span class="bold">株式会社アルク アルクお客様センター</span></p>
              </div>
              <div class="f_box">
                  <p><span class="bold" v-html="ShopConstants.COMPANY_ADDRESS_RECEIPT"></span></p>
              </div>
            </div>
          </div>
        </div>

        <!-- MOBILE VERSION ---------------------->
        <div id="container" name="fm1" class="noprint receipt-details-mobile">
          <img src="../../assets/ALClogo-3-blk.png" id="logo"/>
          <span class="caption">ALC PRESS INC.</span>
         <div id="top_right">
            <div class="t_column clearfix">
            <p class="t_topic">決済確認日<br />INVOICE DATE</p>
              <span id="invoice-date" class="field">{{this.eowp.receiptParams.invoiceDate}}</span>
            </div>
            <div class="t_column clearfix">
            <p class="t_topic">注文番号<br />ORDER NUMBER</p>
              <span id="order-number" class="field">{{this.eowp.receiptParams.orderNumber}}</span>
            </div>
            <div class="t_column clearfix">
            <p class="t_topic">照会番号<br />INQUIRY NUMBER</p>
             <span id="inquiry-number" class="field">{{this.eowp.receiptParams.inquiryNumber}}</span>
            </div>
        </div>
        <div id="main">
            <h2 id="receipt">領収書<br />RECEIPT</h2>
            <p id="certify">
            下記、正に領収いたしました。<br />This is to certify that ALC PRESS
            INC. has received the following.
            </p>
            <div id="wrapper">
            <div class="m_column">
              <div class="m_topic">
                  <p class="m_topic_p">宛名<br />RECEIVED FROM</p>
              </div>
              <div class="m_column_body">
                  <p id="sama">様</p>
              </div>
            </div>
            </div>
            <div class="m_column clearfix">
            <div class="m_topic">
                <p class="m_topic_p">金額<br />THE SUM OF</p>
            </div>
            <div id="sum_fields">
                <p id="yen">&#165;</p>
                <span id="sum" class="field">{{this.eowp.receiptParams.paymentPrice}}<br /></span>
                <p id="credit_card">クレジットカードによるお支払い</p>
            </div>
            </div>
            <div class="m_column clearfix">
            <div class="m_topic">
                <p class="m_topic_p">但し<br />IN PAYMENT OF</p>
            </div>
            <div class="m_column_body">
                <p id="payment_p" v-if="this.$route.query.subscriptionType == this.eowp.receiptType.yearly">
                <span id="payment-of" class="field">
                    {{eowp.receiptParams.itemName}}ご利用料金({{this.formatDateSpecific(eowp.receiptParams.invoiceDate)}} - {{this.formatDateSpecific(eowp.receiptParams.expireDate)}}分)
                </span>
                </p>
                <p id="payment_p" v-else>
                <span id="payment-of" class="field">
                    {{eowp.receiptParams.itemName}}ご利用料金({{this.formatDateSpecific(eowp.receiptParams.invoiceDate)}}分)
                </span>
                </p>
            </div>
            </div>
            <p id="notification">
            本紙は電子的に保持している領収データを画面上で表示したものです<br />This
            is an electronic display of receipt data.
            </p>
            <div id="footer">
              <div class="f_box">
                  <p><span class="bold">株式会社アルク アルクお客様センター</span></p>
              </div>
              <div class="f_box">
                  <p><span class="bold" v-html="ShopConstants.COMPANY_ADDRESS_RECEIPT"></span></p>
              </div>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@charset "UTF-8";

div.container-wide{
  max-width: 2400px!important;
}

/*---全体のルール---*/
* {
  margin: 0px;
  padding: 0px;
}

a {
  color: #0000EE
}
/*---clearfix---*/
/* For modern browsers */
.clearfix:before,
.clearfix:after {
  content: "";
  display: block !important;
  overflow: hidden !important;
}

.clearfix:after {
  clear: both;
}

/* For IE 6/7 (trigger hasLayout) */
.clearfix {
  zoom: 1;
}
/*---clearfixここまで---*/

span.field {
  font-family: "Arial", "ＭＳ ゴシック", "Osaka-等幅", monospace;
}
span.bold {
  font-weight: bold;
}
body,p,#logo, #sum_fields, #top_right, #clearfix, .caption{
  color: #151515;
}
p,h2 {
  font-family: "Arial", "ＭＳ Ｐゴシック", "Osaka", sans-serif;
}
div#container {
  padding-left: 55px!important;
  padding-top: 50px!important;
  padding-bottom: 60px!important;
  max-width: 710px!important;
  margin: 8px auto 30px;
  padding: 5mm 8mm;
  border: solid 1px #000;
}

.caption {
  display: block;
}

#noReceipt {
  text-align: center;
}

#top_right {
  margin-top: 12px;
  margin-left: 395px;
}
.t_column,
.m_column {
  border-bottom: solid 1px #bbbbbb;
}
.t_column {
  width: 200px;
  padding: 8px 8px 6px;
  position: relative;
}
p.t_topic {
  width: 100px;
  font-size: 8pt;
  float: left;
}
.t_column span.field {
  font-size: 12pt;
}
#invoice-date,
#order-number,
#inquiry-number {
  margin-left: 100px;
  padding-top: 10px;
  width: 95px;
  position: relative;
  display: block;
}
h2#receipt {
  clear: both;
  margin-top: 60px;
  text-align: center;
  font-size: 22px;
}
p#certify {
  margin: 50px 39px 20px;
  font-size: 11pt;
}
.m_column {
  margin-bottom: 8px;
  padding: 8px 0 6px 8px;
}
div.m_topic {
  width: 150px;
  float: left;
}
p.m_topic_p {
  font-size: 10pt;
  line-height: 1.4em;
}
.m_column_body {
  width: 433px;
  margin-left: 110px;
}

div#main {
  width: 158mm;
}

p#sama {
  margin-left: 350px;
  margin-top: 2px;
  font-size: 21pt;
}
#sum_fields {
  margin-left: 150px;
}
p#yen {
  float: left;
  margin-right: 8px;
}
p#yen,
#sum {
  height: 25px;
  font-size: 21pt;
}
#sum {
  width: 130px;
  float: left;
}
p#in_tax {
  padding-top: 11px;
  font-size: 11pt;
}
span#yen_tax {
  margin-right: 8px;
}
p#credit_card {
  font-size: 10pt;
  clear: left;
}
#payment_p {
  width: 433px;
  font-size: 10pt;
  letter-spacing: 0.02em;
  line-height: 1.4em;
}

div#print_caution {
  width: 172mm;
  margin: 8px auto 0;
}
p.print_caution_title {
  font-size: 13.5pt;
}

p.print_caution_p {
  font-size: 12pt;
}

p.print_link {
  font-size: 18pt;
}

div#back_button {
  padding-top: 8px;
  padding-bottom: 10px;
  text-align: center;
}

div#back_button input {
  height: 24px;
  width: 150px;
}

p#notification {
  margin-top: 16px;
  margin-left: 8px;
  font-size: 7pt;
}
#footer {
  margin-top: 30px;
  margin-left: 320px;
}
.f_box {
  margin-top: 10px;
  width: 280px;
}
.f_box p {
  font-size: 8pt;
  letter-spacing: 0.01em;
}

/*---ALC LOGO---*/
img#logo {
  vertical-align: top;
  display: inline-block;
  text-align: center;
  height: 45px;
}

@media screen and (max-width: 710px) {
	.receipt-details-standard {
		display: none!important;
	}
	.receipt-details-mobile {
		display: block!important;
	}
	#top_right {
		float: right;
		padding-bottom: 60px;
	}
	div#main {
		width: auto;
	}
	h2#receipt {
		text-align: center;
	}
	#wrapper {
		margin-left: auto;
		margin-right: auto;
	}
	#footer {
		float: right;
	}
	div#container {
		overflow: hidden;
		margin: 25px;
		padding-left: 35px !important;
	}
	.m_column_body {
		width: auto;
		margin-left: 10px;
		overflow: hidden;
	}
	p#sama {
		margin-right: 70px;
		float: right;
		clear: left;
	}
	.t_column {
		text-overflow: ellipsis;
	}
	p#payment_p {
		margin-right: 70px;
		clear: left;
	}
}

@media screen and (min-width: 711px) {
	.receipt-details-standard {
		display: block!important;
	}
	.receipt-details-mobile {
		display: none!important;
  }
}

 @media screen and (max-width: 696px) {
  #payment_p{
    width: auto;
    margin-right: 10px !important;
  }
  p#sama {
		margin-right: 10px;
		float: right;
		clear: left;
	}
 }

 @media screen and (max-width: 641px) {
  p#certify {
    text-align: justify;
    margin: 49px 9px 20px;
	}
 }

@media screen and (max-width: 429px) {
	#sum {
		width: auto;
	}
}

@media screen and (max-width: 407px) {
	p#notification {
		margin-left: 0px;
	}
}

 @media screen and (max-width: 580px) {
  div#print_caution{
    width: auto !important;
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media screen and (max-width: 399px) {
    div.m_topic {
      width: 100px;
    }
    div#sum_fields{
      margin-left: 100px;
    }
    p#certify {
      margin: 49px 5px 20px;
    }
    div#footer {
      font-size: 7pt;
      padding-top: 15px;
      display: contents;
    }
    p#credit_card, #payment_of{
      font-size: 9pt;
    }
    p#notification {
      font-size: 8pt;
      margin-bottom: 25px;
    }
    div#main{
      overflow-wrap: normal;
    }
    .f_box{
      width: auto;
      font-size: 9pt;
    }
  }

@media screen and (max-width: 375px) {
	p#credit_card, #payment_of{
		font-size: 8pt;
  }
}

@media screen and (max-width: 321px) {
  p#certify {
    font-size: 9pt;
  }
}

@media screen and (max-width: 296px) {
	p#yen, #sum, p#sama{
		font-size: 14pt;
  }
  p.m_topic_p{
    font-size: 9pt;
    width: 95px;
  }
  p#sama{
    padding-bottom: 18px;
  }
}

@media screen and (max-width: 308px) {
  #top_right{
    margin-top: 30px;
    display: contents;
    width: 100px;
  }
  .t_column{
    width: auto;
  }
	#invoice-date,#order-number,#inquiry-number {
    margin-left: 0px;
		font-size: 9pt;
	}
}
</style>

<style>
/*Separate block for Printing - Only add css that are related for receipt print out*/
@media print {
    #print_caution {
      display: none!important;
    }
    div.m_column_body {
        margin-bottom: 20px;
    }
    .receipt-details-standard {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
        padding: 15px;
        font-size: 14px;
        line-height: 18px;
    }
    .ui-to-top {
        display: none;
    }
    .page-header {
        display: none !important;
    }
    .page {
        position: relative;
        overflow: hidden;
        min-height: 0vh !important;
    }
    footer {
        display: none !important;
        page-break-after: avoid;
    }
    div.noprint {
        display: none;
    }
    div#container {
      width: 695px!important;
      min-height: 968px !important;
      max-height: 100% !important;
    }
}
/* End of print out css */
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import Utils from "../../js/helpers/Utils";
import ShopConstants from '../../js/helpers/ShopConstants';

export default {
    data() {
        return {
            eowp: {
                receiptParams: {
                    invoiceDate: '',
                    orderNumber: '',
                    inquiryNumber: '',
                    paymentPrice: '',
                    timestamp: '',
                    expireDate: '',
                    itemName: '',
                },
                receiptType: {
                    monthly: 'MONTHLY',
                    yearly: 'YEARLY'
                },
                commonItemReferenceTypes: {
                    EOWP_YEARLY_ITEM: 'EOWP_YEARLY_ITEM',
                    EOWP_YEARLY_S_ITEM: 'EOWP_YEARLY_ITEM',
                    EOWP_MONTHLY_ITEM: 'EOWP_MONTHLY_ITEM',
                },
                paramError: '',
                receiptUnavailable: 'この領収書はすでに発行済みのため、ご覧いただくことができません。', //This Receipt cannot be opened. It appears that this Receipt has been viewed already previously.
                receiptPrintCautionTitle: '▼下の「印刷する」をクリックし、このページをプリンターで印刷することで領収書としてご利用いただけます。',
                receiptPrintCaution: '※宛名は空欄で出力されます。印刷後にご自身でご記入ください。<br />※領収書の発行は、各明細ごとに１回限りです。印刷の完了までは、ブラウザーの「戻る」ボタンや「更新／再読み込み」の操作をなさらないよう、ご注意ください。<br />（PDFファイルに出力して、後日印刷していただくことも可能です）',
                defaultRedirect: '/products'
            },
            showReceipt: '',
            ShopConstants: ShopConstants
        };
    },
    async created() {
        //refresh the session details stored in storage
        await this.fetchSessionDetails(this.userSessionId);

        //check session & userId validity
        if(this.$route.query.sessionId != this.sessionDetails.sessionId || this.$route.query.userId != this.sessionDetails.userId) {
            this.logActivity({type: "info", message: "Redirecting to Products page, invalid or expired session for user with userId: " + this.sessionDetails.userId + " and sessionId: " + this.sessionDetails.sessionId});
            this.$router.push(this.eowp.defaultRedirect);
        }

        // Pull receipt information
        await this.retrieveReceiptInfo({orderNo: this.$route.query.orderNo, paymentLogSeq: this.$route.query.paymentLogSeq}).then(res => {
            this.showReceipt = res.records.receiptIssuedStatus == '0' ? true : false;
            this.eowp.receiptParams.invoiceDate = Utils.formatDate(res.records.invoiceDate);
            this.eowp.receiptParams.expireDate = this.getExpireDate(this.eowp.receiptParams.invoiceDate);
            this.eowp.receiptParams.paymentPrice = Utils.numberToCurrency(res.records.paymentPrice);
            this.eowp.receiptParams.orderNumber = this.$route.query.orderNo;
            this.eowp.receiptParams.inquiryNumber = res.records.inquiryNumber;
        });

        // Let's make sure we got the most up-to-date products reference
        if(Utils.isEmpty(this.products) || this.products.length <= 0){
            await this.retrieveProducts();
        }
        await this.getReceiptItemInfo({custId: this.sessionDetails.userId, orderId: this.eowp.receiptParams.orderNumber}).then(res => {
            if(res.records && !Utils.isEmpty(res.records.productName)){
                let commonItemReferenceType = this.eowp.commonItemReferenceTypes[res.records.itemType];
                let itemNameSource = this.products.filter(item => item.itemType == commonItemReferenceType);
                this.eowp.receiptParams.itemName = !Utils.isEmpty(itemNameSource) && itemNameSource.length > 0 ? itemNameSource[0].productName : res.records.productName;
                this.updateReceiptStatus({orderNo: this.$route.query.orderNo, paymentLogSeq: this.$route.query.paymentLogSeq});
            } else {
                // We might as well redirect them to somewhere else default if we can't show itemName for this receipt. Maybe the item is disabled/not available 
                this.logActivity({type: "info", message: "Redirecting to Products page, unable to show itemName for receipt for user with userId: " + this.sessionDetails.userId});
                this.$router.push(this.eowp.defaultRedirect);
            }
        });
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            userSessionId: 'user/session',
            sessionDetails: 'user/session_details',
            products: 'ncs/products',
        })
    },
    methods: {
        ...mapActions({
            getReceiptItemInfo: 'ncs/getReceiptItemInfo',
            retrieveReceiptInfo: 'ncs/retrieveReceiptInfo',
            retrieveProducts: 'ncs/retrieveProducts',
            updateReceiptStatus: 'ncs/updateReceiptStatus',
            fetchSessionDetails: 'user/fetchSessionDetails',
            logActivity: 'log/logActivity',
            trackClickEvent: 'ga/trackClickEvent',

        }),
        isEmpty(object){
            return Utils.isEmpty(object);
        },
        printReceipt(){
            this.trackClickEvent({event: 'issue_receipt_click', path: this.$route.path, title: this.$route.meta.title});
            window.print();
        },
        formatDateSpecific(value){
          let date = new Date(value);
          let formattedDate = date.getFullYear() + "年" + (date.getMonth()+1).toString().padStart(2, '0') + "月";
          if (Utils.isEmpty(value)) return value;
            return formattedDate;
        },
        getExpireDate(value){
            let expireDate = new Date(value);
            expireDate.setFullYear(expireDate.getFullYear() + 1);
            expireDate.setMonth(expireDate.getMonth() - 1);
            return expireDate;
        }
    }
};
</script>
